var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPontoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.511719 3.089844 C 4.496094 3.125 4.480469 7.847656 4.472656 13.582031 L 4.460938 24 L 7.433594 24 L 7.417969 15.03125 C 7.410156 6.914062 7.414062 6.050781 7.492188 5.980469 C 7.566406 5.90625 8.097656 5.894531 12.703125 5.894531 C 17.300781 5.894531 17.84375 5.90625 17.917969 5.980469 C 17.988281 6.050781 18 6.664062 18 11.949219 C 18 17.234375 17.988281 17.84375 17.917969 17.917969 C 17.84375 17.988281 17.4375 18 14.1875 18 C 11.3125 18 10.527344 18.015625 10.511719 18.0625 C 10.496094 18.097656 10.480469 19.449219 10.476562 21.066406 L 10.460938 24 L 13.433594 24 L 13.417969 22.554688 C 13.414062 21.679688 13.429688 21.074219 13.460938 21.027344 C 13.503906 20.957031 14 20.941406 17.203125 20.921875 L 20.894531 20.894531 L 20.894531 3.050781 L 12.714844 3.035156 C 6.199219 3.027344 4.527344 3.035156 4.511719 3.089844 Z M 4.511719 3.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.511719 9.089844 C 10.496094 9.125 10.492188 10.445312 10.496094 12.027344 L 10.511719 14.894531 L 14.894531 14.894531 L 14.894531 9.050781 L 12.714844 9.035156 C 11 9.027344 10.527344 9.035156 10.511719 9.089844 Z M 10.511719 9.089844 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontoon);
export default __webpack_public_path__ + "static/media/pontoon.c09b7fab.svg";
export { ForwardRef as ReactComponent };